




















































































































































import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import { AccionesInterface } from '@/interfaces/Acciones';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { Validator } from 'vee-validate';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class AccionesModalNuevo extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;

  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Acciones;
  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  informacionGeneral: PermisoAccionVm = {
    accion: 'Crear - Información General',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
    codigoSubAccion: 19,
  };

  permisosTotales: PermisoAccionVm[] = [this.informacionGeneral];

  // Globales
  $snotify: any;
  e1: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = false;
  validForm: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  dictionaryFormErrors: any = {};
  estadoElecto: any = '';
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //data
  estadosServices: EstadosService = new EstadosService();
  estados: EstadoInterface[] = this.estadosServices.getEstadosVisibles();
  estadoSeleccionado: any = null;

  //Interface
  editedItem: AccionesInterface = {};

  //controllers
  readonly controller: string = 'Accion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  constructor() {
    super();
    this.registrarValidadores();
  }

  created() {
    this.chequearPermisos();
  }

  mounted() {
    this.initialize();
  }

  private registrarValidadores() {
    const self = this;

    Validator.extend('accionNombreUnico', {
      getMessage(field: any, params: any, data: any) {
        return '* Ya existe una Acción con este nombre.';
      },
      validate(value: any) {
        if (value !== '') {
          return self.axios.http
            .get(`${self.controller}/${0}/${value}/ChequearNombreUnico`)
            .then(response => {
              return new Promise(resolve => {
                resolve({
                  valid: response.data,
                  data: response.data
                    ? undefined
                    : {
                        message: '* Ya existe una Acción con este nombre.',
                      },
                });
              });
            })
            .catch(err => {
              return true;
            });
        } else {
          return true;
        }
      },
    });
  }

  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        nombre: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          alpha_num: () =>
            '* El Número de serie solo debe contener números y/o letras.',
        },
        descripcion: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          alpha_num: () =>
            '* El Número de serie solo debe contener números y/o letras.',
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  async continuar() {
    const resultado = await this.$validator.validateAll();
    if (resultado) {
      if (this.e1 == 1 && this.disabledAccion === true) {
        this.dialogConfirmacion = true;
        this.btnBloquear = true;
      } else if (this.e1 == 1) {
        this.dialogConfirmacion = true;
        this.btnBloquear = true;
      }
    }
  }

  async confirmCallback(aceptado: boolean) {
    this.dialogConfirmacion = false;

    if (aceptado) {
      await this.postAccion();
    }
    this.btnBloquear = false;
  }

  async postAccion() {
    let self = this;
    this.loadingService.showLoading();
    let he = new HandleErrors();
    this.editedItem.id = 0;

    let model = {
      nombre: this.editedItem.nombre,
      descripcion: this.editedItem.descripcion,
      estado: this.estadoSeleccionado,
    };

    this.axios.http
      .post(`${self.controller}`, model)
      .then(res => {
        this.loadingService.hideLoading();
        this.$snotify.success(
          this.$t('mensajes.mensajesExito.crear', {
            entidad: 'Acción',
            creadoA: 'creada',
          })
        );
        this.closeModal(false);
        this.dialogConfirmacion = false;
      })
      .catch(error => {
        //he.showError(error);
        this.loadingService.hideLoading();
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error(
              this.$t('mensajes.mensajesError.crear', {
                entidad: 'la Acción',
              })
            );
          }
        } else {
          this.$snotify.error(
            this.$t('mensajes.mensajesError.crear', {
              entidad: 'la Acción',
            })
          );
        }
      });
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivAcciones').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset(); //Reset Validaciones
    this.dialog = false;
    this.warningInactivo = '';
    this.mensajeConfirmacion = '';
  }

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
    this.btnText = 'Continuar';
    this.btnClass = 'btn-continuar';
    this.$validator.reset();
    this.loadingService.showLoading();
    this.estadoSeleccionado = EstadoEntidad.Activo; //Estado Activo0
    this.loadingService.hideLoading();
    this.btnBloquear = false;
    this.mensajeConfirmacion = this.$t('mensajes.crud.crear.mensaje', {
      entidad: 'la Acción',
    });
  }

  seleccionarEstado(tipoEstado: any) {
    this.estadoElecto = tipoEstado;

    switch (this.estadoElecto) {
      case 1: // estado Activo
        this.warningInactivo = '';
        this.mensajeConfirmacion = this.$t('mensajes.crud.crear.mensaje', {
          entidad: 'la Acción',
        });
        this.disabledAccion = false;

        break;

      case 0: // estado Inactivo
        this.warningInactivo = this.$t('mensajes.crud.inactivo.mensaje');
        this.mensajeConfirmacion =
          this.warningInactivo +
          ' ' +
          this.$t('mensajes.crud.crear.mensaje', {
            entidad: 'la Acción',
          });
        this.disabledAccion = true;
        break;
    }
  }
}
